import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {formSize, ROUTE_ANIMATIONS_ELEMENTS, tableSize} from "../../../animations/router-animation";
import {fadeIn} from "../../../animations/basic-animation";
import {concat} from "rxjs";


@Component({
  selector: 'app-shared-layout',
  templateUrl: './shared-layout.component.html',
  styleUrls: ['./shared-layout.component.scss'],
  animations: [formSize, tableSize, fadeIn],
})
export class SharedLayoutComponent implements OnInit, OnChanges {
  @Input() Analysis = '';
  @Input() addButtonName = 'Create';
  @Input() subtitle = '';
  @Input() loading = false;
  @Input() formTitle = '';
  @Input() addPermission: string[] = [];
  @Input() helpText = '';
  @Input() showHelp = true;
  @Input() menus = [];
  @Input() dropMenuOnCreate: any[] = [];
  @Input() useDropdownOnCreate?: any;
  @Input() secondaryWithStyle?: boolean = true;

  @Input() viewDetails = false;
  @Input() hideAdd = false;
  @Input() smallForm = true;
  @Input() hideBreadcrumb = false;
  @Input() usePercentageProgressBar = false;
  @Input() useEvaluationProgressBar = false;


  @Input() billsFiltering: any[] = [];

  @Output() addItem = new EventEmitter();
  @Output() addBill = new EventEmitter();
  @Output() closeDetails = new EventEmitter();
  @Output() evaluationCompleted = new EventEmitter();
  @Output() buttonMenuAction = new EventEmitter();
  @Input() animationSize: 'eighty' | 'sixty' | 'largeForm' | 'full' = 'sixty';
  @Input() image: any;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  //props for backarrow and its title 
  @Input() useBackButton: boolean = false;

  @Output() billsFilter = new EventEmitter();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    /*    if (changes.formTitle) {
          this.formTitle = changes.formTitle.currentValue;
        }*/
  }

  ngOnInit() {}

  closeForm() {
    this.closeDetails.emit();
  }

  onButtonMenuAction($event) {
    this.buttonMenuAction.emit($event);
  }

  protected readonly concat = concat;
}
